<template>
  <!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px">
    <el-radio-button :label="false">expand</el-radio-button>
    <el-radio-button :label="true">collapse</el-radio-button>
  </el-radio-group> -->
  <el-menu default-active="/codebook" class="el-menu-vertical-demo" :collapse="isCollapse" @open="handleOpen"
           @close="handleClose" router>
    <el-menu-item index="/home">
      <el-icon>
        <HomeFilled/>
      </el-icon>
      <template #title>
        首页
      </template>
    </el-menu-item>
    <el-menu-item index="/codebook" id="ref2">
      <el-icon>
        <icon-menu/>
      </el-icon>
      <template #title>
        账户管理
      </template>
    </el-menu-item>
    <el-menu-item index="/file">
      <el-icon>
        <document/>
      </el-icon>
      <template #title>
        内容存储
      </template>
    </el-menu-item>
    <el-menu-item index="/logger">
      <el-icon>
        <document/>
      </el-icon>
      <template #title>服务日志</template>
    </el-menu-item>
    <el-menu-item index="/security" id="ref1">
      <el-icon>
        <setting/>
      </el-icon>
      <template #title>安全设置</template>
    </el-menu-item>
  </el-menu>


  <el-tour v-model="open" @change="changeTour" @finish="finishTour">
    <el-tour-step
        target="#ref1" title="安全设置" placement="right"
        description="新注册用户，请先进行安全设置。">
    </el-tour-step>
    <el-tour-step
        target="#ref2"
        title="账户管理"
        placement="right"
        description="建立密钥后，即可进行账户管理。"
    />
  </el-tour>
</template>


<script lang="ts" setup>
import {inject, onMounted, ref} from 'vue'
import type {ButtonInstance} from 'element-plus'
import {
  Document,
  Menu as IconMenu,
  Setting, HomeFilled,
} from '@element-plus/icons-vue'
import R from "@/utils/r";
import SecurityService from "@/api/security";
import router from "@/router";

const ref1 = ref<ButtonInstance>()
const ref2 = ref<ButtonInstance>()
const open = ref(false)
const changeTour = (current: number) => {
  if (current == 0) {
    router.push('/security');
  } else if (current == 1) {
    router.push('/codebook');
  }
}
const finishTour = () => {
  localStorage.setItem("tour", "1");
}

const securityService = inject('securityService') as SecurityService;

const isCollapse = ref(false)
const handleOpen = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}
const handleClose = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}

// 在组件挂载后获取数据
onMounted(async () => {
  // 调用服务端接口获取用户数据
  const isShown = localStorage.getItem("tour");
  if (isShown != '1') {
    //则判断密码是否生成，如果没有则加载漫游引导
    securityService.checkLastUsable().then((data: any) => {
      if (R.isSuccess(data)) {
        if (data.t == null) {
          open.value = true;
          router.push('/security');
        }
      }
    });
  }
});

</script>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>
